<html #invoice>
<head>
<style>
    @media print {
    @page {
        margin: 0;
        padding: 2rem;
    }
    }
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    html, body {
        height: 100%;
        font-family: Arial, sans-serif;
        background: #f5f5f5;
    }

    .factura {
        width: 800px;
        min-height: 100vh;
        margin: 0 auto;
        background: #fff;
        display: flex;
        flex-direction: column;
    }

    /* HEADER Y FOOTER COMO IMÁGENES */
    .footer img {
        width: 100%;
        display: block;
    }

    /* PLACEHOLDER DE PRUEBA: sustituye la cabecera real (header.png) hasta tener los datos reales */
    .header {
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px dashed #c00;
        margin-bottom: 0.5rem;
    }

    .header-placeholder-test {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 28px;
        font-weight: bold;
        color: #1E2A6B;
        letter-spacing: 1px;
    }

    .header-placeholder-test img {
        width: 64px;
        height: 64px;
    }

    .header-invoice {
        display: flex;
        align-items: stretch;
        border-bottom: 2px solid #c00;
    }

    .almacenes {
        flex: 0 0 50%;
        font-size: 10px;
        line-height: 1.5;
        color: #000;
        padding-right: 14px;
    }

    .almacenes .alm-titulo {
        color: #c00;
        font-weight: bold;
    }

    .almacenes .alm-bloque {
        margin-bottom: 6px;
    }

    .almacenes p {
        margin: 0;
        color: #3E5B9B;
    }

    .proveedor {
        flex: 1;
        padding: 12px 14px;
        font-size: 12px;
        line-height: 1.6;
    }

    /* CONTENIDO CENTRAL OCUPA EL ESPACIO SOBRANTE */
    .contenido {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    /* BLOQUE SUPERIOR (tabla roja) */
    .info {
        border-top: 2px solid #c00;
        border-bottom: 2px solid #c00;
        padding: 8px;
    }

    .info table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }

    .info td {
        border: 1px solid #ccc;
        padding: 6px;
    }

    /* TABLA PRINCIPAL (azul) */
    .detalle {
        border: 2px solid #2b5dab;
        margin: 10px;
        border-radius: 6px;
        overflow: hidden;
    }

    .detalle table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }

    .detalle th {
        background: #f0f4ff;
        color: #000;
        border-bottom: 1px solid #ccc;
        padding: 6px;
        text-align: left;
    }

    .detalle td {
        padding: 6px;
        border-bottom: 1px solid #eee;
    }

    .right {
        text-align: right;
    }

    /* TOTALES */
    .totales {
        margin: 10px;
        border: 1px solid #ccc;
        border-radius: 6px;
        overflow: hidden;
        font-size: 12px;
    }

    .totales table {
        width: 100%;
        border-collapse: collapse;
    }

    .totales td {
        border: 1px solid #ccc;
        padding: 6px;
        text-align: center;
    }

    .total-final {
        background: #f8dede;
        font-weight: bold;
    }

    .pago {
        display: flex;
        padding: 10px;
        font-size: 12px;
    }

    .pago > div:last-child {
        margin-left: 50px;
    }

    .pago p {
        margin: 0;
    }
</style>
</head>
<body>

<div class="factura">
    <!-- HEADER COMO IMAGEN -->
    <div class="header">
        <div class="header-placeholder-test">
            <img src="/logo.svg" alt="Logo Plumap">
            EMPRESA DE PRUEBA
        </div>
    </div>

    <div class="header-invoice">
        <div class="almacenes">
            <div class="alm-bloque">
                <p><span class="alm-titulo">ALMACEN: </span> CALLE DE PRUEBA, S/N</p>
                <p>Telf./Fax: 000 00 00 00</p>
                <p><strong>00000 CIUDAD DE PRUEBA (PROVINCIA DE PRUEBA)</strong></p>
            </div>
        </div>
        <div class="proveedor">
        <p>{{ provider.name }}</p>
        <p>{{ provider.address }}</p>
        <p>{{ provider.city }}</p>
        <p>{{ provider.postal_code }}&nbsp;&nbsp;&nbsp;{{ provider.province }}</p>
        <p>{{ provider.email }}</p>
        <p>{{ provider.phone_1 }}</p>
        </div>
    </div>
    <!-- CONTENIDO CENTRAL -->
    <div class="contenido">

        <!-- TABLA SUPERIOR (ROJA) -->
        <div class="info">
            <table>
                <tr>
                    <td><strong>Fecha</strong><br>{{ purchase.date |date:'dd/MM/yyyy' }}</td>
                    <td>
                        <strong>{{ getDocumentLabel(purchase.type) }}</strong>
                        <br>{{ purchase.id_by_company }}/{{ purchase.year }}</td>
                    <td><strong>Cód. Proveedor</strong><br>{{ provider.id_by_company }}</td>
                    <td><strong>CIF/DNI</strong><br>{{ provider.nif }}</td>
                    <td><strong>Observaciones</strong>{{ purchase.notes }}</td>
                </tr>
            </table>
        </div>

        <!-- TABLA DETALLE (AZUL) -->
        <div class="detalle">
            <table>
                <thead>
                    <tr>
                        <th class="center">Artículo</th>
                        <th class="center">Concepto</th>
                        <th class="center">Uds</th>
                        <th class="center">Cantidad</th>
                        <th class="center">Precio</th>
                        <th class="center">Dto.</th>
                        <th class="center">Importe</th>
                        <th class="center">Importe IVA</th>
                    </tr>
                </thead>
                <tbody>
                @for (line of purchaseLines; track line; let i = $index) {
                    <tr>
                        <td class="center">{{ line.code }}</td>
                        <td class="center">{{ line.pivot?.personalized_desc ?? line.name }}</td>
                        <td class="center">{{ line.measurement?.short_name }}</td>
                        <td class="center">{{ line.pivot.quantity }}</td>
                        <td class="center" [centToEurDisplay]='line.pivot.price'></td>
                        <td class="center">{{ line.pivot.discount }}%</td>
                        <td class="center" [centToEurDisplay]='line.pivot.price * line.pivot.quantity'></td>
                        <td class="center" [centToEurDisplay]='line.pivot.price * line.pivot.quantity * (1 + line.pivot.tax / 100)'></td>
                    </tr>
                }
                </tbody>
            </table>
        </div>

        <!-- TOTALES -->
        <div class="totales">
            <table>
                <tr>
                    <td>Total Neto<br><strong [centToEurDisplay]='purchase.subtotal'></strong></td>
                    <td>% Dto.<br><strong>{{ purchase.discount }}</strong></td>
                    <td>% IVA<br><strong>{{ purchaseLines[0]?.pivot?.tax }} %</strong></td>
                    <td>IVA<br><strong [centToEurDisplay]='purchase.total - purchase.subtotal'></strong></td>
                    <td class="total-final">TOTAL<br><span [centToEurDisplay]='purchase.total'></span></td>
                </tr>
            </table>
        </div>

    </div>
        <!-- FORMA DE PAGO -->
    <div class="pago">
        <div>
            <strong>Forma de pago:</strong><br>
            {{ pay_method?.name }}
        </div>
    </div>

</div>
</body>
</html>
